import React from 'react';
import { useUIStore } from '../../../../stores/uiStore';
import { getTranslation } from '../../../../i18n';

const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

interface PageSizeSelectProps {
  value: number;
  onChange: (size: number) => void;
}

const PageSizeSelect: React.FC<PageSizeSelectProps> = ({ value, onChange }) => {
  const { language } = useUIStore();
  const t = (key: string) => getTranslation(language, key);

  return (
    <div className="flex items-center gap-2">
      <span className="text-xs text-content-muted">{t('amlPageSizeShow')}</span>
      <select
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="px-2 py-1.5 rounded-lg border border-subtle bg-surface-primary text-content text-xs outline-none focus:border-brand/40 transition-all cursor-pointer"
      >
        {PAGE_SIZE_OPTIONS.map((opt) => (
          <option key={opt} value={opt}>{opt}</option>
        ))}
      </select>
      <span className="text-xs text-content-muted">{t('amlPageSizePerPage')}</span>
    </div>
  );
};

export default PageSizeSelect;
